import { createSlice } from "@reduxjs/toolkit";
import { fetchTransactionsThunk } from "../../services/MasterApi"; 

const initialState = {
    data: [],
    isLoading: false,
    error: null,
    pagination: {},
}

const transationTableSlice = createSlice({
    name: "transationSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactionsThunk.pending, (state)=> {
                state.isLoading = true;
                state.error = null;
                state.data = [];
                state.pagination = {};
            })
            .addCase(fetchTransactionsThunk.fulfilled, (state, action)=> {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload?.payload?.content?.businesses || [];
                state.pagination = action.payload?.pagination || {};
            })
            .addCase(fetchTransactionsThunk.rejected, (state, action)=> {
                state.isLoading = false;
                state.error = action.payload;
                state.data = [];
                state.pagination = {};
            })
    }
})

export default transationTableSlice.reducer